import { render, staticRenderFns } from "./bayi_tahsilatlari.vue?vue&type=template&id=18ecd60d"
import script from "./bayi_tahsilatlari.vue?vue&type=script&lang=js"
export * from "./bayi_tahsilatlari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports